/* eslint max-len:0 */
const Slovak = {
    _language: 'slovak',
    _language_short: 'sk',
    agentWelkomMessage: 'Vitajte. Zadajte svoju otázku tu.',
    conversationTimestampHeaderFormat: 'HH:mm',
    couldNotConnect: 'Nepodarilo sa pripojiť. Môžete to {retry}',
    couldNotConnectInner: 'skúsiť znova pripojiť teraz',
    couldNotConnectWithRetry: 'Nepodarilo sa pripojiť. Budeme to skúšať znova, alebo môžete {retry}.',
    couldNotConnectWithRetryInner: 'skúsiť teraz',
    headerText: 'Ako vám môžeme pomôcť?',
    imageClickToReload: 'Kliknite na opätovné načítanie obrázka.',
    imageClickToView: 'Kliknite na zobrazenie obrázka {size}.',
    imagePreviewNotAvailable: 'Náhľad nie je dostupný.',
    inputPlaceholder: 'Píšte sem, stlačte <enter> na odoslanie.',
    inputPlaceholderBlocked: 'Vyplňte formulár vyššie...',
    introAppText: 'Pošlite svoju správu nižšie alebo cez váš obľúbený kanál.',
    introductionText: 'Zadajte svoju otázku tu.',
    actionPaymentCompleted: 'Platba prijatá.',
    actionPaymentError: 'Počas spracovania platby došlo k chybe. <br> Skúste to znova alebo použite inú kartu.',
    actionPostbackError: 'Počas spracovania vašej akcie došlo k chybe. Skúste to znova.',
    clickToRetry: 'Správu sa nepodarilo doručiť. Skúste to znova.',
    clickToRetryForm: 'Formulár nebol odoslaný. Kliknite kdekoľvek na formulár na opätovné odoslanie.',
    connectNotificationText: 'Počkajte na odpoveď alebo si vyberte aplikáciu, v ktorej chcete pokračovať.',
    connectNotificationSingleText: 'Počkajte na odpoveď alebo si vyberte aplikáciu, v ktorej chcete pokračovať.',
    connectNotificationSingleButtonText: 'Zapnúť upozornenia <name>',
    connectNotificationOthersText: 'iné',
    emailChangeAddress: 'Zmeniť môj e-mail',
    emailDescription: 'Ak chcete byť informovaní e-mailom o odpovedi, zadajte svoju e-mailovú adresu.',
    emailFieldLabel: 'Váš e-mail',
    emailFieldPlaceholder: 'Vaša e-mailová adresa',
    emailFormButton: 'Pokračovať',
    fetchHistory: 'Načítať viac',
    fetchingHistory: 'Načítavam históriu...',
    frontendEmailChannelDescription: 'Pošlite nám e-mail a my sa vám čo najskôr ozveme.',
    invalidFileError: 'Podporované sú iba obrázky. Vyberte súbor s podporovanou príponou (jpg, jpeg, png, gif alebo bmp).',
    lineChannelDescription: 'Naskenujte QR kód a spojte sa s nami cez LINE.',
    locationNotSupported: 'Váš prehliadač nepodporuje lokalizačné služby alebo boli zakázané. Zadajte svoju polohu manuálne.',
    locationSecurityRestriction: 'Táto webová stránka nemôže získať prístup k vašej polohe. Zadajte ju manuálne.',
    locationSendingFailed: 'Nepodarilo sa odoslať polohu',
    locationServicesDenied: 'Táto webová stránka nemôže získať prístup k vašej polohe. Povoľte prístup v nastaveniach alebo zadajte polohu manuálne.',
    messageError: 'Počas odosielania správy došlo k chybe. Skúste to znova.',
    messageIndicatorTitlePlural: '({count}) Nové správy',
    messageIndicatorTitleSingular: '({count}) Nová správa',
    messageRelativeTimeDay: 'Pred {value} dňami',
    messageRelativeTimeHour: 'Pred {value} h',
    messageRelativeTimeJustNow: 'Práve teraz',
    messageRelativeTimeMinute: 'Pred {value} min',
    messageTimestampFormat: 'h:mm A',
    messageSending: 'Odosielanie...',
    messageDelivered: 'Doručené',
    messengerChannelDescription: 'Pripojte svoj Facebook účet a pokračujte cez Facebook Messenger.',
    whatsappChannelDescriptionDesktop: 'Chcete začať alebo pokračovať v konverzácii cez WhatsApp? Kliknite na odkaz nižšie.',
    whatsappChannelDescriptionMobile: 'Chcete začať alebo pokračovať v konverzácii cez WhatsApp? Kliknite na odkaz nižšie.',
    whatsappLinkingError: 'Pri pripájaní sa vyskytla chyba. Skúste to znova.',
    notificationSettingsChannelsDescription: 'Môžete s nami komunikovať aj cez svoju obľúbenú aplikáciu alebo službu.',
    notificationSettingsChannelsTitle: 'Iné aplikácie',
    notificationSettingsConnected: 'Pripojené',
    notificationSettingsConnectedAs: 'Pripojené ako {username}',
    prechatCaptureGreetingText: 'Ahoj 👋\nNajskôr by sme sa o vás chceli dozvedieť viac:',
    prechatCaptureNameLabel: 'Vaše meno',
    prechatCaptureNamePlaceholder: 'Zadajte svoje meno...',
    prechatCaptureEmailLabel: 'E-mail',
    prechatCaptureEmailPlaceholder: 'meno@firma.com',
    prechatCaptureConfirmationText: 'Ďakujeme! Ako vám môžeme pomôcť?',
    prechatCaptureMailgunLinkingConfirmation: 'Odpoveď vám bude zaslaná sem aj na e-mail {email}.',
    sendButtonText: 'Odoslať',
    settingsHeaderText: 'Nastavenia',
    smsBadRequestError: 'Nepodarilo sa pripojiť k tomuto číslu. Skúste to znova alebo použite iné číslo.',
    smsCancel: 'Zrušiť',
    smsChangeNumber: 'Zmeniť moje číslo',
    smsChannelDescription: 'Pripojte svoje SMS číslo a pokračujte cez SMS.',
    smsChannelPendingDescription: 'Skontrolujte svoje správy na {number}, aby ste potvrdili svoje telefónne číslo.',
    smsContinue: 'Pokračovať',
    smsInvalidNumberError: 'Vaše telefónne číslo nie je platné. Skúste to znova.',
    smsLinkCancelled: 'Prepojenie s {appUserNumber} bolo zrušené.',
    smsLinkPending: 'Čaká sa na potvrdenie',
    smsPingChannelError: 'Pri odosielaní správy na vaše číslo došlo k chybe.',
    smsSendText: 'Pošlite mi správu',
    smsStartTexting: 'Začať chatovať',
    smsTooManyRequestsError: 'Pre toto číslo bol nedávno odoslaný požiadavok na pripojenie. Skúste to znova o {minutes} minút.',
    smsTooManyRequestsOneMinuteError: 'Pre toto číslo bol nedávno odoslaný požiadavok na pripojenie. Skúste to znova o 1 minútu.',
    smsUnhandledError: 'Nastala chyba. Skúste to znova.',
    tapToRetry: 'Správa nebola doručená. Stlačte enter na opätovné odoslanie.',
    tapToRetryForm: 'Formulár nebol odoslaný. Kliknite kdekoľvek na formulár na opätovné odoslanie.',
    telegramChannelDescription: 'Pripojte svoj Telegram účet a pokračujte cez Telegram.',
    unsupportedMessageType: 'Nepodporovaný typ správy.',
    unsupportedActionType: 'Nepodporovaný typ akcie.',
    linkError: 'Pri generovaní odkazu pre tento kanál došlo k chybe. Skúste to znova.',
    viberChannelDescription: 'Pripojte svoj Viber účet a pokračujte cez Viber.',
    viberChannelDescriptionMobile: 'Pripojte svoj Viber účet, aby ste boli informovaní o odpovedi a mohli pokračovať v konverzácii na Vibere. Ak chcete začať, nainštalujte si aplikáciu Viber a klepnite na Pripojiť.',
    viberQRCodeError: 'Pri načítaní vášho Viber QR kódu došlo k chybe. Skúste to znova.',
    wechatChannelDescription: 'Pripojte svoj WeChat účet, aby ste boli informovaní o odpovedi a mohli pokračovať v konverzácii na WeChat. Ak chcete začať, naskenujte tento QR kód pomocou aplikácie WeChat.',
    wechatChannelDescriptionMobile: 'Pripojte svoj WeChat účet, aby ste boli informovaní o odpovedi a mohli pokračovať v konverzácii na WeChat. Ak chcete začať, uložte si tento QR kód a nahrajte ho do <a href="weixin://dl/scan">skenera QR kódov</a>.',
    wechatQRCodeError: 'Pri načítaní vášho WeChat QR kódu došlo k chybe. Skúste to znova.',
    fileTooLargeError: 'Prekročený maximálny limit veľkosti súboru ({size})',
    shareLocation: 'Zdieľať polohu',
    uploadDocument: 'Nahrať dokument',
    uploadInvalidError: 'Neplatný súbor',
    fileTypeError: 'Nepodporovaný typ súboru',
    formErrorInvalidEmail: 'Neplatná e-mailová adresa',
    formErrorNoLongerThan: 'Musí obsahovať najviac ({characters}) znakov',
    formErrorNoShorterThan: 'Musí obsahovať aspoň ({characters}) znakov',
    formErrorUnknown: 'Toto nevyzerá správne',
    formFieldSelectPlaceholderFallback: 'Vyberte jednu možnosť...',
    uploadPhoto: 'Nahrať fotografiu',
    uploadVirusError: 'Vo vašom súbore bol zistený vírus a bol odmietnutý',
    shoutoutText: 'Začať chat',
    cardClickText: 'Vybrané'
};
export { Slovak };
